// extracted by mini-css-extract-plugin
export default {"authCard":"Login_authCard__CdXqN","authLogo":"Login_authLogo__c+1ES","authClose":"Login_authClose__uPvKG"};